let angularInjector;

export function setAngularInjector(injector) {
  angularInjector = injector;
}

/**
 * This is a workaround solution that we use while we migrate parts of the application to React. For more complex React
 * pages it isn't practical to pass services to the top level page component and then pass them down to all children
 * for when a grandchild or lower component needs the service. In a full React application you would use a hook or
 * context to access the data from the component that needs it. To simulate this we can create hooks that access the
 * data already stored inside Angular services. Calls to this function can be removed from the hook when all state and
 * logic live outside of Angular.
 * @param {string} serviceName The name of an angular service we want to access.
 */
export function getAngularService(serviceName) {
  if (!angularInjector) {
    // Reference for a fix: https://hotjar.atlassian.net/browse/EE-1742
    throw new Error('No cached angular injector found.');
  }

  return angularInjector.get(serviceName);
}
